<h2 mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content class="webcam-content">
  @if (errorMessage()) {
    <div class="error-message">
      <mat-icon>error</mat-icon>
      <p>{{ errorMessage() }}</p>
    </div>
  } @else {
    @if (showWebcam()) {
      <div class="webcam-wrapper">
        <webcam
          [trigger]="webcamTriggerObservable"
          [switchCamera]="switchCameraObservable"
          [allowCameraSwitch]="false"
          (imageCapture)="handleImage($event)"
          (initError)="handleInitError($event)"
          [imageQuality]="0.92"></webcam>
        @if (availableCameras() > 1) {
          <button type="button" class="camera-switch-button" (click)="switchCamera()" [title]="translateService.instant('liveforms-editor.common.buttons.switch-camera')">
            <mat-icon>cameraswitch</mat-icon>
          </button>
        }
      </div>
    } @else if (capturedImage()) {
      <img [src]="capturedImage()!.imageAsDataUrl" alt="Captured photo" />
    }
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (showWebcam() && !errorMessage()) {
    <button mat-raised-button color="primary" (click)="triggerCapture()">
      <mat-icon>photo_camera</mat-icon>
      {{ translateService.instant('liveforms-editor.photo-item.webcam.capture') }}
    </button>
  }

  @if (capturedImage()) {
    <button mat-stroked-button (click)="retake()">
      <mat-icon>refresh</mat-icon>
      {{ translateService.instant('liveforms-editor.photo-item.webcam.retake') }}
    </button>
    <button mat-raised-button color="primary" (click)="confirm()">
      <mat-icon>check</mat-icon>
      {{ translateService.instant('liveforms-editor.photo-item.webcam.use-photo') }}
    </button>
  }

  <button mat-button (click)="cancel()">
    {{ translateService.instant('liveforms-editor.photo-item.webcam.cancel') }}
  </button>
</mat-dialog-actions>
